/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { Suspense, useEffect, useState, useRef, lazy } from 'react';
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.css";
import axios from 'axios';
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";
import parser from "html-react-parser";

const modifyLastName = (name) => {
  if (name.includes("Mcgee")) {
    return name.replace("Mcgee", "McGee");
  }
  return name;
}

export default function Body({ realtorData, loanOfficerActive, loanOfficerData, angelAiUserInfo }) {
  const imgCDNURL = process.env.REACT_APP_CDN + "homeownership-program/";
  const realtorName = realtorData ? modifyLastName(capitalizeFirstLetter(realtorData.name)) : "";
  const angelAiName = angelAiUserInfo ? capitalizeFirstLetter(angelAiUserInfo.angelAIUserInfo.fullName) : "";
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();




  useEffect(() => {
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);


  let mobilePhoneNumberFormatted,
    mobilePhoneNumberWithInternationalCode,
    mobilePhoneNumberInTitle,
    workPhoneNumberFormatted,
    workPhoneNumberWithInternationalCode,
    workPhoneNumberInTitle;
  try {
    mobilePhoneNumberFormatted = realtorData ? formatPhoneNumber(
      realtorData.mobilePhoneNumber
    ) : "";
    mobilePhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.mobilePhoneNumber,
      "+1"
    ) : "";
    mobilePhoneNumberInTitle = "Contact me at " + mobilePhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor mobile phone number.", error);
  }

  try {
    workPhoneNumberFormatted = realtorData ? formatPhoneNumber(realtorData.workPhoneNumber) : "";
    workPhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.workPhoneNumber,
      "+1"
    ) : "";
    workPhoneNumberInTitle = "Contact me at " + workPhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor work phone number.", error);
  }

  function scrollToSection1() {
    const sectionPosition = document.getElementById("contactusform").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="">
        <Container>
          {realtorData ? (
            <Row className="">
              <Col sm={12} md={12} xl={12} lg={12} className='loanofficer-col'>
                <div className="loinfodiv">
                  <div className="lo-img-bg">
                    <img
                      src={realtorData.profileImage}
                      className="lo-img img-fluid"
                      alt={realtorName}
                    />
                    <div className='lo-text'>
                      <p className="namejoaqu">{realtorName}</p>
                      <p className="namejo2">
                        {realtorData.license ? (
                          <>
                            NMLS {realtorData.license}
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        {realtorData.designation ? (
                          <>
                            {realtorData.designation}
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        
                        {realtorData.mobilePhoneNumber ? (
                          <>
                            {/* <img src={francmob} alt="realtor mobile icon" /> */}
                            <a
                              style={{ textDecoration: "none" }}
                              href={"tel:" + mobilePhoneNumberWithInternationalCode}
                              title={mobilePhoneNumberInTitle}
                              aria-label={mobilePhoneNumberInTitle}
                            >
                              {mobilePhoneNumberFormatted}
                            </a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        {realtorData.workPhoneNumber ? (
                          <>
                            {/* <img src={franctel} alt="realtor telephone icon" /> */}
                            <a
                              style={{ textDecoration: "none" }}
                              href={"tel:" + workPhoneNumberWithInternationalCode}
                              title={workPhoneNumberInTitle}
                              aria-label={workPhoneNumberInTitle}
                            >
                              D: {workPhoneNumberFormatted}
                            </a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        {realtorData.emailAddress ? (
                          <>
                            {/* <img src={francemail} alt="realtor email icon" /> */}
                            <a
                              style={{ textDecoration: "none" }}
                              href={"mailto:" + realtorData.emailAddress}
                              title={"Email me at " + realtorData.emailAddress}
                              aria-label={"Email me at " + realtorData.emailAddress}
                            >
                              {realtorData.emailAddress}
                            </a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        {realtorData.userWebsite ? (
                          <>
                            {/* <img src={francweb} alt="realtor website icon" /> */}
                            <a
                              style={{ textDecoration: "none" }}
                              href={realtorData.userWebsite}
                              target="_blank"
                            >
                              {realtorData.userWebsite.replace(/^https?:\/\//, "")}
                            </a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        
                        {realtorData.streetAddress ? (
                          <>
                            {/* <img src={franclocation} alt="realtor location icon" /> */}
                            <a
                              style={{ textDecoration: "none" }}
                              rel="noreferrer"
                            >{realtorData.streetAddress}<br></br> {realtorData.cityStateZip}</a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                        
                        {realtorData.branchNMLS ? (
                          <>
                            {realtorData.branchNMLS}
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Container>
      </div>
      <div id="gettrueapproveScroll"></div>
    </>
  );
}
